import * as yup from "yup";
import rules from "./rules";
const nameRegex = /^[A-Za-z ]+$/;
// const message = /^[A-Za-z0-9 ;:-+=?!.,\(\)]+$/;

const ruless = {
  name: yup
    .string()
    .matches(nameRegex, "Only English letters")
    .min(2)
    .max(35, "Must be exactly 15 characters")
    .required("Name is a required field"),
  first_name: yup
    .string()
    .matches(nameRegex, "Only English letters")
    .min(2)
    .max(15, "Must be exactly 15 characters")
    .required("First name is a required field"),
  middle_name: yup.string().nullable(),
  last_name: yup
    .string()
    .matches(nameRegex, "Only English letters")
    .min(2)
    .max(15, "Must be exactly 15 characters")
    .required("Last name is a required field"),
  email: yup.string().email("Email must be a valid email").required("Email is a required field"),
  terms: yup.string().test("terms", "Terms of Service is a required field", (value) => {
    return !!value;
  }),
  // middle_name: yup.string().nullable(),
  // password: yup.string().min(6).required("Password is a required field"),
  // password_confirmation: yup.string()
  //   .when("edit", {
  //     is: false,
  //     then: yup.string(),
  //     otherwise: yup.string(),
  //   })
  //   .oneOf([yup.ref("password")], "Passwords do not match"),
  // password: yup.string().when("edit", {
  //   is: false,
  //   then: yup.string()
  //     .matches(
  //       /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[~!@#$%^&*()\-_=+{};:,<.>?\'\[\]]){1,})([A-Za-z0-9~!@#$%^&*()\-_=+{};:,<.>?\'\[\]]{8,30})$/,
  //       "One uppercase and lowercase letter required, 8 characters minimum (max 30 characters), one number required, one of the following special characters: ~!@#$%^&*()-_=+{};:,<.>?'[]"
  //     )
  //     .required("Password is a required field"),
  //   otherwise: yup.string().test('password', "One uppercase and lowercase letter required, 8 characters minimum (max 30 characters), one number required, one of the following special characters: ~!@#$%^&*()-_=+{};:,<.>?'[]",
  //     (val) => {
  //       if (!val) return true;
  //       return /^(?=(?:.*[A-Z]){1,})(?=(?:.*[a-z]){1,})(?=(?:.*\d){1,})(?=(?:.*[~!@#$%^&*()\-_=+{};:,<.>?\'\[\]]){1,})([A-Za-z0-9~!@#$%^&*()\-_=+{};:,<.>?\'\[\]]{8,30})$/.test(val)
  //     }
  //   )
  // }),
  password_confirmation: yup.string().when("password", {
    is: (v) => !!v,
    then: yup
      .string()
      .oneOf([yup.ref("password")], "Passwords do not match")
      .required("Password confirmation is a required field"),
    otherwise: yup.string(),
  }),
  // accountNumber: yup.string()
  //   .matches(nameRegex, "Only English letters")
  //   .min(2)
  //   .max(15, "Must be exactly 15 characters")
  //   .nullable("Account Number is a required field"),

  message: yup
    .string()
    // .matches(message, "Only English letters and 0-9;:-+=?!.,()")
    .min(10, "Min 10 characters")
    .max(500, "Must be exactly 500 characters")
    .required("Message is a required field"),
};

export default (name, args) => {
  // let shape = {}
  // rul.map(r => shape[r] = rules[r])
  return yup.object().shape(rules[name]);
};
